
import React from "react";
import { Check } from "lucide-react";
import ValueProposition from "@/components/ValueProposition";

const CoachingApproach = () => {
  return (
    <ValueProposition
      id="coaching-approach"
      title="Der Mensch hinter den Zahlen – Mein Coaching-Ansatz"
      description="Als Finanzcoach sehe ich meine Rolle nicht darin, dir vorzuschreiben, was zu tun ist. Vielmehr schaffe ich einen Raum, in dem du als Mensch mit deinen Werten, Zielen und Ängsten gesehen wirst. Ich unterstütze dich dabei, deine eigenen finanziellen Entscheidungen zu treffen und Potenziale zu entfalten – auf eine Weise, die zu dir passt."
      image="/lovable-uploads/ba343bae-43f9-4e77-90b7-c0266b5e397c.png"
      imageAlt="Ruhiger See mit Bäumen - Symbolisiert Klarheit und Balance im Finanzcoaching"
      backgroundColor="bg-joerg-50"
    >
      <div className="mt-2 space-y-3">
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600">
            Vollständig unabhängige und neutrale Begleitung
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600">
            Keine versteckten Provisionen oder Verkaufsinteressen
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600">
            Fokus auf deine persönlichen Werte und Bedürfnisse
          </span>
        </div>
      </div>
    </ValueProposition>
  );
};

export default CoachingApproach;
